import Vue from 'vue'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import locale from 'element-ui/lib/locale/lang/en' // lang i18
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
// import VueUploadImgs from 'vue-upload-imgs'
import '@/styles/index.scss' // global css
import App from './App'
import store from './store'
import router from './router'

import '@/icons' // icon
import '@/permission' // permission control
import '@/websocket/websocket' //wnpm install vue@next -Sebsocket


import VueNotionRender from "vue-notion-render" 






import 'vue-beauty/package/style/vue-beauty.min.css'
Vue.use(VueNotionRender)
import vueBeauty from 'vue-beauty'
Vue.use(vueBeauty)

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
// if (process.env.NODE_ENV === 'production') {
//   const { mockXHR } = require('../mock')
//   mockXHR()
// }

// set ElementUI lang to EN
Vue.use(ElementUI, { locale })

// 如果想要中文版 element-ui，按如下方式声明
// Vue.use(ElementUI)
// Vue.use(VueUploadImgs)


// main.js
// import uView from "uview-ui";
// Vue.use(uView);

// Vue.use(date)

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
